import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '../../../components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card'
import { WeightHistoryItem } from './WeightHistoryItem'
import { ChevronDown, ChevronUp, History } from 'lucide-react'

const INITIAL_COUNT = 7

export function WeightHistory({ entries, onUpdate, onDelete }) {
  const { t } = useTranslation()
  const [showAll, setShowAll] = useState(false)

  if (entries.length === 0) {
    return (
      <Card>
        <CardContent className="py-8 text-center text-muted-foreground">
          {t('phoenixTracker.weight.noEntries')}
        </CardContent>
      </Card>
    )
  }

  const visible = showAll ? entries : entries.slice(0, INITIAL_COUNT)
  const hasMore = entries.length > INITIAL_COUNT

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2">
          <History className="w-4 h-4 text-app-primary-500" />
          {t('phoenixTracker.weight.weight').replace(' (kg)', '')}
          <span className="text-xs font-normal text-muted-foreground">({entries.length})</span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {visible.map((entry) => (
            <WeightHistoryItem
              key={entry.id}
              entry={entry}
              onUpdate={onUpdate}
              onDelete={onDelete}
            />
          ))}
        </div>
        {hasMore && (
          <div className="mt-3 text-center">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setShowAll(!showAll)}
              className="text-app-primary-500 hover:text-app-primary-600 hover:bg-app-primary-50 dark:hover:bg-app-primary-900/20"
            >
              {showAll ? (
                <>
                  <ChevronUp className="w-4 h-4 mr-1" />
                  {t('phoenixTracker.weight.showLess')}
                </>
              ) : (
                <>
                  <ChevronDown className="w-4 h-4 mr-1" />
                  {t('phoenixTracker.weight.showMore')} ({entries.length - INITIAL_COUNT})
                </>
              )}
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  )
}
